import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from 'redux/store';
import { TranslationInfo } from 'redux/schemas/models/edit-translations';
import { getLectureComponent } from 'redux/selectors/timeline';
import { ComponentType, NLectureComponent } from 'redux/schemas/models/lecture-component';
import { revealAnswers } from 'redux/actions/quizzes';
import LoadingPlaceholder from 'shared/components/loading-placeholder';
import EditableQuizBase from './quiz-base/editable-quiz-base';

type EditableProps = {
  editInfo: TranslationInfo,
  containerClass: string,
  onSaveRef: (fn: () => void) => void,
  setSavingDisabled: (boolean) => void,
};

const EditableSingleViewQuiz = ({
  editInfo,
  containerClass,
  onSaveRef,
  setSavingDisabled,
}: EditableProps) => {
  const lectureComponent = useSelector((state) => (
    getLectureComponent(state, editInfo.id)
  )) as NLectureComponent<ComponentType.PROGRESSIVE_QUIZ>;
  const currentQuiz = useSelector((state) => state.models.progressiveQuizzes[lectureComponent.progressiveQuiz]);
  const [hasLoadedQuestions, setHasLoadedQuestions] = useState(false);
  const dispatch = useAppDispatch();
  useEffect(() => {
    // Here we call "revealAnswers" to get questions, options and hints
    dispatch(revealAnswers({ questionSetId: currentQuiz.id })).then(() => {
      setHasLoadedQuestions(true);
    });
  }, []);
  const currentQuestions = useSelector((state) => (
    hasLoadedQuestions
      ? currentQuiz.questions?.map((questionId) => {
        const { questionText, type, horizontalAxisLabel, verticalAxisLabel, numRows, numColumns, translationIds: qTranslationIds } = state.models.quizQuestions[questionId];
        const currentQuestion = {
          question: {
            id: questionId,
            questionText,
            type,
            horizontalAxisLabel,
            verticalAxisLabel,
            numRows,
            numColumns,
            translationIds: qTranslationIds,
          },
          options: state.models.quizQuestions[questionId].responseOptions?.map((optionId) => {
            const { optionContent, readOnly, explanation, secondaryExplanation, translationIds: oTranslationIds } = state.models.quizQuestionOptions[optionId];
            return {
              id: optionId,
              optionContent,
              readOnly,
              explanation,
              secondaryExplanation,
              translationIds: oTranslationIds,
            };
          }),
          hints: state.models.quizQuestions[questionId].attemptFeedbacks?.map((hintId) => {
            const { feedbackText, translationIds: oTranslationIds } = state.models.quizQuestionFeedbacks[hintId];
            return {
              id: hintId,
              feedbackText,
              translationIds: oTranslationIds,
            };
          }),
        };
        return currentQuestion;
      })
      : null
  ), [hasLoadedQuestions]);
  return (
    <React.Fragment>
      {
        hasLoadedQuestions
          ? (
            <EditableQuizBase
              componentType={ComponentType.PROGRESSIVE_QUIZ}
              currentQuiz={currentQuiz}
              currentQuestions={currentQuestions}
              containerClass={containerClass}
              onSaveRef={onSaveRef}
              setSavingDisabled={setSavingDisabled}
              lectureComponent={lectureComponent}
              editInfo={editInfo}
            />
          )
          : (
            <LoadingPlaceholder className='w-100' />
          )
      }
    </React.Fragment>
  );
};


export default EditableSingleViewQuiz;
